(function(){
  "use strict";

  document.addEventListener('DOMContentLoaded', function(){

    /* ---- Menu mobile (hambúrguer) ---- */
    var toggle = document.getElementById('guiapeNavToggle');
    var menu = document.getElementById('guiapeNavMenu');

    if(toggle && menu){
      function closeMenu(){
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded','false');
        toggle.setAttribute('aria-label','Abrir menu de navegação');
      }
      function openMenu(){
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded','true');
        toggle.setAttribute('aria-label','Fechar menu de navegação');
      }
      toggle.addEventListener('click', function(){
        if(menu.classList.contains('is-open')){ closeMenu(); } else { openMenu(); }
      });
      menu.addEventListener('click', function(e){
        if(e.target.closest('a')){ closeMenu(); }
      });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && menu.classList.contains('is-open')){ closeMenu(); toggle.focus(); }
      });
    }

    /* ---- Sombra do header ao rolar ---- */
    var header = document.querySelector('.guiape-header');
    if(header){
      function onScroll(){
        if(window.scrollY > 8){ header.classList.add('is-scrolled'); }
        else { header.classList.remove('is-scrolled'); }
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }

    /* ---- Revelar elementos ao rolar ---- */
    var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var alvos = document.querySelectorAll('.reveal');
    if(reduz || !('IntersectionObserver' in window)){
      alvos.forEach(function(el){ el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
      alvos.forEach(function(el){ io.observe(el); });
    }

    /* ---- Slideshow de fotos no hero ----
       As URLs das fotos vêm de data-photos (JSON) no elemento #guiapeHeroSlides,
       preenchido pela seção via Liquid (asset_url de cada imagem). */
    var cont = document.getElementById('guiapeHeroSlides');
    if(cont){
      var fotos = [];
      try{ fotos = JSON.parse(cont.dataset.photos || '[]'); }catch(e){ fotos = []; }
      var TEMPO = parseInt(cont.dataset.interval, 10) || 6000;

      var slides = fotos.map(function(src){
        var d = document.createElement('div');
        d.className = 'hero-slide';
        d.dataset.src = src;
        cont.appendChild(d);
        return d;
      });
      function carregar(i){
        var s = slides[i];
        if(s && !s.dataset.loaded){ s.style.backgroundImage = "url('" + s.dataset.src + "')"; s.dataset.loaded = "1"; }
      }
      if(slides.length){
        var atual = 0;
        carregar(0);
        slides[0].classList.add('is-active');
        if(!reduz && slides.length > 1){
          carregar(1);
          setInterval(function(){
            var prox = (atual + 1) % slides.length;
            carregar(prox);
            slides[atual].classList.remove('is-active');
            slides[prox].classList.add('is-active');
            atual = prox;
            carregar((prox + 1) % slides.length);
          }, TEMPO);
        }
      }
    }

    /* ---- Modais de Termos de Uso / Política de Privacidade ---- */
    function fecharModais(){
      document.querySelectorAll('.modal-legal').forEach(function(m){ m.hidden = true; });
      document.body.classList.remove('modal-aberto');
    }
    document.querySelectorAll('[data-modal-open]').forEach(function(trigger){
      trigger.addEventListener('click', function(e){
        e.preventDefault();
        var modal = document.getElementById(trigger.dataset.modalOpen);
        if(!modal){ return; }
        modal.hidden = false;
        document.body.classList.add('modal-aberto');
      });
    });
    document.querySelectorAll('[data-modal-close]').forEach(function(closer){
      closer.addEventListener('click', fecharModais);
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ fecharModais(); }
    });

    /* ---- Galeria da Amostra do Ebook ---- */
    var amostraModal = document.getElementById('modalAmostra');
    if(amostraModal){
      var amostraSlides = Array.prototype.slice.call(amostraModal.querySelectorAll('.amostra-slide'));
      var amostraTotal = amostraSlides.length;
      var amostraAtual = 0;
      var amostraContador = document.getElementById('amostraAtual');
      var amostraAnterior = amostraModal.querySelector('.amostra-anterior');
      var amostraProxima = amostraModal.querySelector('.amostra-proxima');

      function amostraCarregar(i){
        var s = amostraSlides[i];
        if(!s){ return; }
        var img = s.querySelector('img[data-src]');
        if(img){ img.src = img.dataset.src; img.removeAttribute('data-src'); }
      }
      function amostraMostrar(i){
        if(i < 0 || i >= amostraTotal){ return; }
        amostraSlides.forEach(function(s){ s.classList.remove('is-active'); });
        amostraAtual = i;
        amostraSlides[i].classList.add('is-active');
        if(amostraContador){ amostraContador.textContent = amostraAtual + 1; }
        amostraCarregar(amostraAtual);
        amostraCarregar(amostraAtual + 1);
        if(amostraAnterior){ amostraAnterior.disabled = (amostraAtual === 0); }
        if(amostraProxima){ amostraProxima.disabled = (amostraAtual === amostraTotal - 1); }
      }
      if(amostraAnterior){ amostraAnterior.addEventListener('click', function(){ amostraMostrar(amostraAtual - 1); }); }
      if(amostraProxima){ amostraProxima.addEventListener('click', function(){ amostraMostrar(amostraAtual + 1); }); }

      document.addEventListener('keydown', function(e){
        if(amostraModal.hidden){ return; }
        if(e.key === 'ArrowRight'){ amostraMostrar(amostraAtual + 1); }
        if(e.key === 'ArrowLeft'){ amostraMostrar(amostraAtual - 1); }
      });

      var amostraToqueX = null;
      var amostraViewport = amostraModal.querySelector('.modal-amostra-viewport');
      if(amostraViewport){
        amostraViewport.addEventListener('touchstart', function(e){ amostraToqueX = e.touches[0].clientX; }, {passive:true});
        amostraViewport.addEventListener('touchend', function(e){
          if(amostraToqueX === null){ return; }
          var dx = e.changedTouches[0].clientX - amostraToqueX;
          if(Math.abs(dx) > 40){ amostraMostrar(amostraAtual + (dx < 0 ? 1 : -1)); }
          amostraToqueX = null;
        }, {passive:true});
      }

      document.querySelectorAll('[data-modal-open="modalAmostra"]').forEach(function(trigger){
        trigger.addEventListener('click', function(){ amostraMostrar(0); });
      });
    }

    /* ---- Pixel da Meta: intenção de compra ao sair para a Kiwify ---- */
    if(typeof fbq === 'function'){
      document.querySelectorAll('a[href*="kiwify.com.br"]').forEach(function(link){
        link.addEventListener('click', function(){
          var card = link.closest('.card-ebook');
          var titulo = card && card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : undefined;
          fbq('track', 'InitiateCheckout', titulo ? {content_name: titulo} : {});
        });
      });
    }

  });
})();
